import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { IndividualContainer } from "../../routes/individuals/components/IndividualContainer";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  registryId: string;
  individualId: string;
}

export const IndividualModal = ({
  onClose,
  isOpen,
  registryId,
  individualId,
}: IProps) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      closeOnOverlayClick={true}
      size="5xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Individual View</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <IndividualContainer
            registryId={registryId}
            individualId={individualId}
          ></IndividualContainer>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button onClick={onClose}>Close</Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
